import script from "./Companies.vue?vue&type=script&setup=true&lang=js"
export * from "./Companies.vue?vue&type=script&setup=true&lang=js"

import "./Companies.css?vue&type=style&index=0&id=11cb8952&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cb8952"]])

export default __exports__